import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import RoleContext from '../auth/RoleContext.js'
import { ROLES } from '../auth/role'
import { LoadingButton } from '@mui/lab';
import { expandSidebar } from '../layout/Header.js'
import { Article as ArticleIcon, Share as ShareIcon } from '@mui/icons-material'
import AmericanFlagIcon from '../img/flag-usa'
import CanadianFlagIcon from '../img/flag-canada'
import ListActiveLds from './ListActiveLds'
import ListViewCommandBar from '../commandBar/ListViewCommandBar'
import Page from '../layout/Page'
import { Paper } from '@mui/material';


export default function ListActiveLdsPage (props = {}) {
  const [isLoading, setIsLoading] = useState(true)
  const [isEmailDialogVisible, setIsEmailDialogVisible] = useState(false);
  const { regulationId } = useParams();
  const breadcrumb = <span><ArticleIcon/> Label Declaration Sheets (LDS) {regulationId === '4' ? <CanadianFlagIcon/> : <AmericanFlagIcon/>}</span>
  const [selectedRows, setSelectedRows] = useState([]);
  const [showFilters, setShowFilters] = useState(true)

  const toggleFilters = () => {
    setShowFilters(!showFilters)
  }
  
  const handleCheckboxChange = (rowIndex) => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(rowIndex)
        ? prevSelectedRows.filter((index) => index !== rowIndex)
        : [...prevSelectedRows, rowIndex]
    );
  };
   
  const handleShare = () => {
    setIsEmailDialogVisible(true)
  };

  useEffect(() => {
    expandSidebar()
  }, [])

  return (

    <RoleContext.Consumer>
      { roleCtx => (
        <Page { ...props} breadcrumb={breadcrumb} isLoading={isLoading}
          commandBar={
            <ListViewCommandBar showFilters={true} toggleFilters={toggleFilters} showAdd={false} showShare={roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN, ROLES.SRA_USER])} share={
              <LoadingButton loading={isLoading} variant="contained" onClick={handleShare} disabled={selectedRows?.length === 0}>Share&nbsp;&nbsp;<ShareIcon/></LoadingButton>
            }/>
          }>
          <Paper>
            <ListActiveLds 
              showFilters={showFilters} 
              setIsLoading={setIsLoading} 
              onShareCheckboxChange={handleCheckboxChange} 
              selectedRows={selectedRows} 
              setSelectedRows={setSelectedRows} 
              isEmailDialogVisible={isEmailDialogVisible} 
              setIsEmailDialogVisible={setIsEmailDialogVisible}
            />
          </Paper>
        </Page>
      )}
    </RoleContext.Consumer>
  )
}